export const currentLocationIsAvailable = () => currentLocation().then((loc) => Object.keys(loc).length > 0);

// NOTE: if not available returns an empty object so that we can send an empty
// query string to doorkeeper since not all the buildings require location data
export const currentLocation = () =>
  new Promise((res, _rej) => {
    if (!navigator.geolocation) {
      return res({});
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        res({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (_error) => res({}),
      { enableHighAccuracy: true, timeout: 5000 },
    );
  });
